var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 7.5C14.1406 7.71134 14.0567 7.91403 13.9072 8.06348C13.7578 8.21292 13.5551 8.29688 13.3438 8.29688H8.29688V13.3438C8.29688 13.5551 8.21292 13.7578 8.06348 13.9072C7.91403 14.0567 7.71134 14.1406 7.5 14.1406C7.28866 14.1406 7.08597 14.0567 6.93652 13.9072C6.78708 13.7578 6.70312 13.5551 6.70312 13.3438V8.29688H1.65625C1.44491 8.29688 1.24222 8.21292 1.09277 8.06348C0.943331 7.91403 0.859375 7.71134 0.859375 7.5C0.859375 7.28866 0.943331 7.08597 1.09277 6.93652C1.24222 6.78708 1.44491 6.70312 1.65625 6.70312H6.70312V1.65625C6.70312 1.44491 6.78708 1.24222 6.93652 1.09277C7.08597 0.943331 7.28866 0.859375 7.5 0.859375C7.71134 0.859375 7.91403 0.943331 8.06348 1.09277C8.21292 1.24222 8.29688 1.44491 8.29688 1.65625V6.70312H13.3438C13.5551 6.70312 13.7578 6.78708 13.9072 6.93652C14.0567 7.08597 14.1406 7.28866 14.1406 7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBlack);
export default __webpack_public_path__ + "static/media/plus-icon-black.9cab21f63616564d8c2c3d66635dd1fe.svg";
export { ForwardRef as ReactComponent };